'use client';

import { useState } from 'react';
import ProjectCard from './ProjectCard';
import ProjectLightbox from './ProjectLightbox';

interface Project {
  id: string;
  image: string;
  alt: string;
  room: string;
  location: string;
  products: string[];
  description: string;
  installerNotes: string;
}

const projects: Project[] = [
{
  id: 'proj_1',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505123/Lenin_roller_euq3xa.jpg",
  alt: 'Modern living room with white roller blinds and minimalist furniture',
  room: 'Living Room',
  location: 'Bengaluru, Karnataka, India',
  products: ['Linen Roller Blinds', 'Light Filtering'],
  description: 'A stunning modern living room transformation featuring our custom linen roller blinds. The light filtering fabric creates a soft, diffused glow while maintaining privacy throughout the day.',
  installerNotes: 'Inside mount installation with motorized lift system. Custom color match to existing décor. Installation time: 2 hours.'
},
{
  id: 'proj_2',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505113/blackout_project_kvsti9.png",
  alt: 'Bedroom with blackout blinds creating complete darkness to',
  room: 'Bedroom',
  location: 'Chennai, Tamil Nadu, India',
  products: ['Blackout Roman Shades'],
  description: 'Master bedroom retreat with blackout Roman shades providing complete light control for optimal sleep quality. The elegant fabric folds add a sophisticated touch to the space.',
  installerNotes: 'Outside mount for maximum light blocking. Cordless lift for clean look and child safety. Custom length to accommodate low windowsill.'
},
{
  id: 'proj_3',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505131/wooden_project_m5xfyg.png",
  alt: 'Home office with wooden Venetian blinds for adjustable light',
  room: 'Home Office',
  location: 'Hydrabad, Telangana, India',
  products: ['Wood Venetian Blinds'],
  description: 'Professional home office featuring warm wood Venetian blinds. Adjustable slats allow precise control of natural light to reduce screen glare while maintaining a connection to the outdoors.',
  installerNotes: 'Basswood construction with custom stain to match desk. Tilt control on right side per client preference. Easy-clean finish.'
},
{
  id: 'proj_4',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505134/roman_shades_qgiko5.png",
  alt: 'Elegant dining room with Roman shades in neutral tones',
  room: 'Dining Room',
  location: 'Bengaluru, Karnataka, India',
  products: ['Roman Shades', 'Silk Blend'],
  description: 'Formal dining room elevated with luxurious silk blend Roman shades. The soft folds and subtle sheen create an elegant atmosphere perfect for entertaining.',
  installerNotes: 'Lined for enhanced light control and fabric protection. Continuous cord loop for smooth operation on large windows. Professional dry cleaning recommended.'
},
{
  id: 'proj_5',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505126/sunscreen_project_kidwrc.jpg",
  alt: 'Bright kitchen with sheer curtains allowing natural light',
  room: 'Kitchen',
  location: 'Chennai, Tamil Nadu, India',
  products: ['Sunscreen Fabric'],
  description: 'Light-filled kitchen with airy sheer curtains that filter sunlight while maintaining an open, welcoming feel. Perfect for spaces where you want privacy without sacrificing natural light.',
  installerNotes: 'Moisture-resistant fabric suitable for kitchen environment. Ceiling mount to maximize window height. Machine washable for easy maintenance.'
},
{
  id: 'proj_6',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505114/cellular_project_o51muz.png",
  alt: 'Peaceful nursery with cellular shades for insulation',
  room: 'Nursery',
  location: 'Hydrabad, Telangana, India',
  products: ['Cellular Shades', 'Top-Down/Bottom-Up'],
  description: 'Serene nursery featuring energy efficient cellular shades with top-down/bottom-up functionality. Provides flexible light control and temperature regulation for baby\'s comfort.',
  installerNotes: 'Cordless operation for child safety. Double cell construction for maximum insulation. Blackout liner added for nap time.'
},
{
  id: 'proj_7',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505124/motorized_project_gxcegn.png",
  alt: 'Modern smart home with motorized blinds and home automation',
  room: 'Smart Home',
  location: 'Bengaluru, Karnataka, India',
  products: ['Motorized Roller Blinds', 'Smart Integration'],
  description: 'Cutting-edge smart home integration with motorized roller blinds throughout. Automated schedules and voice control create the ultimate in convenience and energy efficiency.',
  installerNotes: 'Wi-Fi enabled motors integrated with home automation system. Solar panel charging for eco-friendly operation. Scheduled programming for optimal energy use.'
},
{
  id: 'proj_8',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773504587/vertical_jzedb0.png",
  alt: 'Patio doors with vertical blinds for large opening coverage',
  room: 'Patio',
  location: 'Chennai, Tamil Nadu, India',
  products: ['Vertical Blinds', 'UV Protection'],
  description: 'Expansive patio doors outfitted with vertical blinds featuring UV protection. Perfect for controlling intense sunlight while maintaining easy access to outdoor spaces.',
  installerNotes: 'Fade-resistant fabric rated for high UV exposure. Left-side draw for furniture clearance. Reinforced headrail for large span.'
},
{
  id: 'proj_9',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505124/Solar_project_bqq4zv.jpg",
  alt: 'Outdoor patio with weather-resistant blinds for sun protection',
  room: 'Outdoor Patio',
  location: 'Hydrabad, Telangana, India',
  products: ['Outdoor Solar Shades'],
  description: 'Desert patio transformed with weather-resistant outdoor solar shades. Blocks harsh afternoon sun while preserving outdoor views and reducing indoor cooling costs.',
  installerNotes: 'Marine grade hardware for extreme weather resistance. 5% openness factor for heat reduction while maintaining visibility. Stainless steel components.'
},
{
  id: 'proj_10',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505105/commercial_project_d3q1ss.png",
  alt: 'Professional commercial office with coordinated blinds throughout',
  room: 'Commercial Office',
  location: 'Bengaluru, Karnataka, India',
  products: ['Commercial Roller Blinds', 'Fire Rated'],
  description: 'Corporate office installation featuring fire-rated commercial roller blinds across 50+ windows. Coordinated color scheme creates professional atmosphere while meeting safety codes.',
  installerNotes: 'Bulk installation completed over weekend to minimize disruption. Fire-rated fabric meets commercial building codes. 5-year commercial warranty included.'
},
{
  id: 'proj_11',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773504356/zebra_c4fiv9.png",
  alt: 'Luxury bedroom suite with layered window treatments',
  room: 'Master Suite',
  location: 'Chennai, Tamil Nadu, India',
  products: ['Layered System', 'Sheer + Blackout'],
  description: 'Luxurious master suite featuring layered window treatment system combining sheer and blackout options. Provides ultimate flexibility for any time of day or mood.',
  installerNotes: 'Dual-track system allows independent operation of sheer and blackout layers. Motorized for both tracks. Custom valance conceals hardware.'
},
{
  id: 'proj_12',
  image: "https://res.cloudinary.com/dsizaxsjm/image/upload/v1773505123/roller_project_n7izwy.png",
  alt: 'Contemporary loft with floor-to-ceiling window treatments',
  room: 'Loft',
  location: 'Hydrabad, Telangana, India',
  products: ['Extra-Long Roller Blinds'],
  description: 'Urban loft with dramatic floor-to-ceiling windows dressed in custom extra-long roller blinds. Clean lines and neutral tones complement the industrial aesthetic.',
  installerNotes: 'Special order extra-long fabric for 12-foot windows. Reinforced roller tube for fabric weight. Dual mounting brackets for stability.'

},
];

const roomFilters = ['All', 'Living Room', 'Bedroom', 'Kitchen', 'Bathroom', 'Office', 'Outdoor'];

export default function ProjectGallery() {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredProjects = activeFilter === 'All' ?
  projects :
  projects.filter((p) => p.room.includes(activeFilter));

  return (
    <>
      {/* Filter Bar */}
      <div data-component-id="src/app/projects/components/ProjectGallery.tsx:155:6" data-component-path="src/app/projects/components/ProjectGallery.tsx" data-component-line="155" data-component-end-line="169" data-component-file="ProjectGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%20mb-12%22%7D" className="flex flex-wrap gap-3 mb-12">
        {roomFilters.map((filter) =>
        <button data-component-id="src/app/projects/components/ProjectGallery.tsx:157:8" data-component-path="src/app/projects/components/ProjectGallery.tsx" data-component-line="157" data-component-end-line="167" data-component-file="ProjectGallery.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={`filter_${filter}`}
          onClick={() => setActiveFilter(filter)}
          className={`px-6 py-3 rounded-full text-sm font-semibold transition-all ${
          activeFilter === filter ?
          'bg-primary text-white shadow-lg' :
          'bg-white text-foreground border-2 border-border hover:border-primary'}`
          }>
          
            {filter}
          </button>
        )}
      </div>

      {/* Gallery Grid */}
      <div data-component-id="src/app/projects/components/ProjectGallery.tsx:172:6" data-component-path="src/app/projects/components/ProjectGallery.tsx" data-component-line="172" data-component-end-line="180" data-component-file="ProjectGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-8%22%7D" className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {filteredProjects.map((project) =>
        <ProjectCard data-component-id="src/app/projects/components/ProjectGallery.tsx:174:8" data-component-path="src/app/projects/components/ProjectGallery.tsx" data-component-line="174" data-component-end-line="177" data-component-file="ProjectGallery.tsx" data-component-name="ProjectCard" data-component-content="%7B%22elementName%22%3A%22ProjectCard%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
          key={project.id}
          {...project}
          onClick={() => setSelectedProject(project)} />

        )}
      </div>

      {/* Lightbox */}
      {selectedProject &&
      <ProjectLightbox data-component-id="src/app/projects/components/ProjectGallery.tsx:184:6" data-component-path="src/app/projects/components/ProjectGallery.tsx" data-component-line="184" data-component-end-line="188" data-component-file="ProjectGallery.tsx" data-component-name="ProjectLightbox" data-component-content="%7B%22elementName%22%3A%22ProjectLightbox%22%7D"
        project={selectedProject}
        allProjects={filteredProjects}
        onClose={() => setSelectedProject(null)}
        onNavigate={(newProject) => setSelectedProject(newProject)} />

      }
    </>);

}